import { useEffect, useState } from "react";

const useDomLoaded = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return loaded;
};

export default useDomLoaded;
